<pagination-template #p="paginationApi" [id]='id' (pageChange)="pageChange.emit($event)">
  <ng-container *ngIf='p.pages.length > 1'>
    <div class="flex flex-col justify-center items-center">
      <div class="flex flex-1 justify-center items-center">
        <div class="flex flex-col  items-center justify-center">
          <button mat-icon-button (click)="p.previous();changeDetection.detectChanges()" [disabled]="p.isFirstPage()">
            <mat-icon [color]="p.isFirstPage()? 'none': 'primary'"> navigate_before</mat-icon>
          </button>
        </div>
        <div class="flex flex-col items-center justify-center" *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value">
          <button  matRipple class="py-2 px-4 rounded-full mx-1" (click)="p.setCurrent(page.value);changeDetection.detectChanges()"
            *ngIf="p.getCurrent() !== page.value">
            <span class="font-semibold opacity-7 text-base text-primary-500" >{{ page.label }}</span>
          </button>
          <div class="mx-2" *ngIf="p.getCurrent() === page.value">
            <span class="font-semibold opacity-7 text-base text-black">{{ page.label }}</span>
          </div>
        </div>
        <div class="flex flex-col items-center justify-center">
          <button mat-icon-button (click)="p.next();changeDetection.detectChanges()" [disabled]="p.isLastPage()">
            <mat-icon [color]="p.isLastPage()? 'none': 'primary'"> navigate_next</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</pagination-template>
